import ActivityListRow from './ActivityListRow';

export default ActivityListRow;
